<script setup>
import { pageRetrieve } from '@/client'
import { client } from '@/lohnrechner'
import { toDash, toUnderscore, useTextStore } from '@/stores/texts'
import { watch } from 'vue'
import { inject, ref } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  slug: {
    type: String,
    required: true
  }
})

const page = ref(null)

let languageStore = useTextStore()

const router = useRouter()

languageStore.$subscribe((mutation, state) => {
  if (!page.value) return
  let lang = toDash(page.value.language)
  if (lang === state.language) return
  for (let translation of page.value.translations) {
    if (toDash(translation.language) !== languageStore.language) continue

    let slug = translation.slug
    if (slug === props.slug) {
      fetchPage()
    } else {
      router.push({ name: 'flat-page', params: { slug: slug } })
    }
  }
})

const setDocTitle = inject('setTitle')
function fetchPage() {
  pageRetrieve({
    path: { slug: props.slug },
    query: { language: toUnderscore(languageStore.language) },
    client
  }).then((response) => {
    page.value = response.data
    setDocTitle(page.value.title)
  })
}
fetchPage()

watch(() => props.slug, fetchPage)
</script>

<template>
  <article v-if="page">
    <h1>{{ page.title }}</h1>
    <div class="content" v-html="page.content"></div>
  </article>
</template>

<style scoped>
h1 {
  font-size: 2rem;
}
</style>

<style>
article h2 {
  color: var(--color-text);
  text-align: left;
  margin-bottom: 0.4rem;
}
</style>
